import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard
} from '../../../share/guards'
import GeoRegionsWidgetEmptyResultGuard from './GeoRegionsWidgetEmptyResultGuard'

const GeoRegionsWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <GeoRegionsWidgetEmptyResultGuard widgetId={widgetId}>
          {children}
        </GeoRegionsWidgetEmptyResultGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default GeoRegionsWidgetDataGuards
